import React, { useState, useCallback, useEffect } from "react";
import ErrorModal from "../components/ui/ErrorModal";
import { ErrorModalContext } from "../context/ErrorModalContext";

export function ErrorModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [message, setMessage] = useState<string | null>(null);

  const showError = useCallback((msg: string) => {
    setMessage(msg);
  }, []);

  // Global JS error handler
  useEffect(() => {
    const onError = () => {
      showError("Something went wrong. An unexpected error occurred.");
    };
    const onUnhandledRejection = () => {
      showError("Something went wrong. An unexpected error occurred.");
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, [showError]);

  return (
    <ErrorModalContext.Provider value={{ showError }}>
      {children}
      <ErrorModal
        open={!!message}
        title="Error"
        onOk={() => setMessage(null)}
        onCancel={() => setMessage(null)}
        okText="OK"
        cancelButtonProps={{ style: { display: "none" } }}
        centered
      >
        <p>{message}</p>
      </ErrorModal>
    </ErrorModalContext.Provider>
  );
}
